import { Box, styled } from '@mui/material';

export const AssemblyPill = styled(Box)(({ theme }) => ({
  background: theme.palette.text.secondary,
  color: theme.palette.background.paper,
  borderRadius: 12,
  padding: '2px 6px',
  fontWeight: 600,
  textTransform: 'uppercase',
  zIndex: 2,
  pointerEvents: 'none',
  lineHeight: 1,
  fontSize: '0.5rem',
  display: 'inline-block',
  whiteSpace: 'nowrap',
  flexShrink: 0,
}));
